import React from "react";
import styles from "./styles.css";
import CheckIcon from "./images/checklist-tick.svg";

const BetterWayTradeInNew = () => {
    return (
        <div>
            <h2 styleName={"styles.heading"}>Get a real offer in 2 minutes</h2>

            <div styleName={"styles.checklistWrap"}>
                <div styleName={"styles.checklist"}>
                    <p styleName={"styles.options"}><img src={CheckIcon} />100% online</p>
                    <p styleName={"styles.options"}><img src={CheckIcon} />We pick up from your home</p>
                    <p styleName={"styles.options"}><img src={CheckIcon} />Convenient virtual inspection</p>
                </div>
            </div>
        </div>
    );
};

export default BetterWayTradeInNew;
